export const dateNow = Date.now;
